var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "../../Button/Button";
import DropdownButton from "../../Button/Dropdown/DropdownButton";
var PageHeadingActions = function (_a) {
    var actions = _a.actions, moreButtonText = _a.moreButtonText, _b = _a.moreButtonType, moreButtonType = _b === void 0 ? "white" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    if (actions.length === 0) {
        return _jsx(_Fragment, {});
    }
    var nonPrimaryActions = actions.filter(function (a) { return !a.primary; });
    var mobileActions = nonPrimaryActions
        .reverse()
        .map(function (action) {
        if (action.actionType === "dropdown") {
            var options = [];
            for (var i = 0; i < action.options.length; i++) {
                for (var j = 0; j < action.options[i].length; j++) {
                    var subAction = action.options[i][j];
                    options.push(subAction);
                }
            }
            return options;
        }
        return [{
                text: action.text,
                icon: action.icon,
                onClick: action.onClick
            }];
    });
    return (_jsxs("div", __assign({ className: "mt-5 flex flex-wrap gap-3 lg:mt-0 lg:ml-4" }, { children: [actions.map(function (action, index) { return (_jsx("span", __assign({ className: "".concat(!action.primary && "hidden sm:block") }, { children: !action.actionType || action.actionType === "button"
                    ?
                        _jsx(Button, { text: action.text, icon: action.icon, iconOnly: action.iconOnly, type: action.type ? action.type : (action.primary ? "primary" : "white"), onClick: action.onClick, disabled: disabled })
                    :
                        _jsx(DropdownButton, { style: action.type ? action.type : (action.primary ? "primary" : "white"), text: action.text, icon: action.icon, iconOnly: action.iconOnly, actions: action.options, disabled: disabled, alignRight: false }) }), index)); }), nonPrimaryActions.length > 0 &&
                _jsx("div", __assign({ className: "relative sm:hidden" }, { children: _jsx(DropdownButton, { style: moreButtonType, text: moreButtonText, disabled: disabled, actions: mobileActions }) }))] })));
};
export default PageHeadingActions;
